const state = {
    phone: '',
    userId: '',
    idCardNumber: '',
    name: '',
    sex: '',
    password: '',
    headImg: '',
    wallet: '',
};

const mutations = {
    setUserId(state, newUserId) {
        state.userId = newUserId;
    },
    setIdCardNumber(state, newIdCardNumber) {
        state.idCardNumber = newIdCardNumber;
    },
    setName(state, newName) {
        state.name = newName;
    },
    setPhone(state, newPhone) {
        state.phone = newPhone;
    },
    setSex(state, newSex) {
        state.sex = newSex;
    },
    setPassword(state, newPassword) {
        state.password = newPassword;
    },
    setHeadImg(state, newHeadImg) {
        state.headImg = newHeadImg;
    },
    setWallet(state, newWallet) {
        state.wallet = newWallet;
    },
    clearUser(state) {
        state.userId = '';
        state.name = '';
        state.phone = '';
        state.idCardNumber = '';
        state.sex = '';
        state.password = '';
        state.headImg = '';
        state.wallet = '';
    },
    setUser(state, userInfo) {
        state.userId = userInfo.id;
        state.idCardNumber = userInfo.idCardNumber || '';
        state.name = userInfo.name || '';
        state.phone = userInfo.phone || '';
        state.sex = userInfo.sex || '';
        state.password = userInfo.password || '';
        state.headImg = userInfo.headImg || '';
    }
};

const actions = {
    updateUserId({ commit }, newUserId) {
        commit('setUserId', newUserId);
    },
    updateIdCardNumber({ commit }, newIdCardNumber) {
        commit('setIdCardNumber', newIdCardNumber);
    },
    updateName({ commit }, newName) {
        commit('setName', newName);
    },
    updatePhone({ commit }, newPhone) {
        commit('setPhone', newPhone);
    },
    updateSex({ commit }, newSex) {
        commit('setSex', newSex);
    },
    updatePassword({ commit }, newPassword) {
        commit('setPassword', newPassword);
    },
    updateHeadImg({ commit }, newHeadImg) {
        commit('setHeadImg', newHeadImg);
    },
    updateWallet({ commit }, newWallet) {
        commit('setWallet', newWallet);
    },
    updateUserInfo({ commit }, userInfo) {
        commit('setUser', userInfo);
    },
    clearUserInfo({ commit }) {
        commit('clearUser');
    }
};

const getters = {
    getUserId(state) {
        return state.userId;
    },
    getIdCardNumber(state) {
        return state.idCardNumber;
    },
    getName(state) {
        return state.name;
    },
    getPhone(state) {
        return state.phone;
    },
    getSex(state) {
        return state.sex;
    },
    getPassword(state) {
        return state.password;
    },
    getHeadImg(state) {
        return state.headImg;
    },
    getWallet(state) {
        return state.wallet;
    },
    getCurrentUserInfo: (state) => {
        return {
            userId: state.userId,
            idCardNumber: state.idCardNumber,
            name: state.name,
            phone: state.phone,
            sex: state.sex,
            password: state.password,
            headImg: state.headImg,
            wallet: state.wallet,
        };
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
